// extracted by mini-css-extract-plugin
export default {"trashIconWrapper":"LibraryVideoSelection-module__trashIconWrapper_FrwPP"};